/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {ApplicationState} from '@/types/redux';

export const selectIsFromLegacy = ({initialization: {isFromLegacyAdmin}}: ApplicationState) => isFromLegacyAdmin;
export const selectInitializationComplete =
    ({initialization: {initializationComplete}}: ApplicationState) => initializationComplete;
